// extracted by css-extract-rspack-plugin
export default {"slideUp":"src-pages-Privacy-PrivacyPopup-module__slideUp-gQ8lYa","slideDown":"src-pages-Privacy-PrivacyPopup-module__slideDown-xlTH2z","banner":"src-pages-Privacy-PrivacyPopup-module__banner-sqYTFI","compactPanel":"src-pages-Privacy-PrivacyPopup-module__compactPanel-zLuQlv","popupLink":"src-pages-Privacy-PrivacyPopup-module__popupLink-rknKEd","iconButton":"src-pages-Privacy-PrivacyPopup-module__iconButton-tMd1Hq","acceptButton":"src-pages-Privacy-PrivacyPopup-module__acceptButton-_59aGZ","declineButton":"src-pages-Privacy-PrivacyPopup-module__declineButton-wYig3i"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"slideUp\":\"src-pages-Privacy-PrivacyPopup-module__slideUp-gQ8lYa\",\"slideDown\":\"src-pages-Privacy-PrivacyPopup-module__slideDown-xlTH2z\",\"banner\":\"src-pages-Privacy-PrivacyPopup-module__banner-sqYTFI\",\"compactPanel\":\"src-pages-Privacy-PrivacyPopup-module__compactPanel-zLuQlv\",\"popupLink\":\"src-pages-Privacy-PrivacyPopup-module__popupLink-rknKEd\",\"iconButton\":\"src-pages-Privacy-PrivacyPopup-module__iconButton-tMd1Hq\",\"acceptButton\":\"src-pages-Privacy-PrivacyPopup-module__acceptButton-_59aGZ\",\"declineButton\":\"src-pages-Privacy-PrivacyPopup-module__declineButton-wYig3i\"}";
        // 1790730172955
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  